import React from "react";
import { LegalLayout, Section } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="January 2026">
      <p>
        Invextiing operates the investor portal at invextiing.com. This policy explains what
        information we collect, why we collect it, and the choices available to you. It applies to the
        client portal and the administrative panel.
      </p>

      <Section heading="1. Information we collect">
        <p>
          We collect only the information required to operate your investment account: your full name,
          email address, phone number, postal address, an optional profile photograph, and the
          financial records maintained by your relationship manager (invested capital, profit figures,
          investment entries and withdrawal entries).
        </p>
      </Section>

      <Section heading="2. How your account is created">
        <p>
          There is no public registration. Accounts are created exclusively by authorised Invextiing
          administrators. Your login credentials are issued to you directly, and passwords are stored
          only as irreversible bcrypt hashes, never in readable form.
        </p>
      </Section>

      <Section heading="3. How we use your information">
        <p>
          Your information is used to authenticate you, to display your portfolio and statements, to
          send password reset emails, and to deliver market notifications from your manager. We do not
          sell, rent, or share your personal information with advertisers or data brokers.
        </p>
      </Section>

      <Section heading="4. Security measures">
        <p>
          All traffic is encrypted in transit using TLS. Sessions use short-lived signed tokens that
          expire automatically. Login and password-reset endpoints are rate limited to deter
          brute-force attempts. Password reset links are single-use and expire within 45 minutes. Every
          administrative change to your record is written to an activity log.
        </p>
      </Section>

      <Section heading="5. Data accuracy and read-only access">
        <p>
          For the integrity of financial reporting, all monetary figures, histories, badges and levels
          are maintained solely by Invextiing administrators. Your portal access to these values is
          read-only. If you believe a figure is incorrect, contact your relationship manager and it
          will be reviewed and corrected with a corresponding audit entry.
        </p>
      </Section>

      <Section heading="6. Data retention">
        <p>
          Account and transaction records are retained for as long as your account is active and for
          the period afterwards required by applicable Indian financial record-keeping regulations.
          Profile photographs are deleted when replaced or when the account is closed.
        </p>
      </Section>

      <Section heading="7. Your rights">
        <p>
          You may request a copy of the personal information we hold, request correction of
          inaccuracies, or request account closure by contacting your relationship manager. We will
          respond within 30 days.
        </p>
      </Section>

      <Section heading="8. Contact">
        <p>
          Questions about this policy can be sent to privacy@invextiing.com. Company address and
          registration details are available on request.
        </p>
      </Section>
    </LegalLayout>
  );
}
